import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";
import {startOfDay} from "date-fns";

export function latitude(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value) {
      const isLatitudeValid = (control.value >= -90) && (control.value <= 90);
      return isLatitudeValid ? null : {latitude: true};
    }
    return null;
  }
}

export function longitude(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value) {
      const isLongitudeValid = (control.value >= -180) && (control.value <= 180);
      return isLongitudeValid ? null : {latitude: true};
    }
    return null;
  }
}

export function dateRange(): ValidatorFn {
  return (form: AbstractControl): ValidationErrors | null => {
    const start: Date = form?.get("startDate")?.value;
    const end: Date = form?.get("endDate")?.value;
    if (start && end) {
      const isRangeValid = (startOfDay(end).getTime() - startOfDay(start).getTime()) >= 0;
      return isRangeValid ? null : {dateRange: true};
    }
    return null;
  }
}

export function isPositiveInteger(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value) {
      const isInteger = parseInt(control.value) == Number(control.value) && Number(control.value) > 0;
      return isInteger ? null : {installationCounter: true};
    }
    return null;
  }
}

export function uppercase(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value) {
      const isUppercase = control.value == control.value.toUpperCase();
      return isUppercase ? null : {uppercase: true};
    }
    return null;
  }
}
